import angular from 'angular';
import TableDirective from './table.directive';

const TableModule = angular
    .module('control-room.commons.data.components.table', [])
    .directive('crTable', TableDirective.directiveFactory);

export default TableModule;
